<template>
  <div class="travel_invitation">
    <!-- 活动标题 -->
    <div v-wechat-title="'时光旅行社-开业邀请函'"></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
      <div @touchmove.prevent class='preloading preloading-travel' v-show='preloadingShow'></div>
    </transition>
    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin'
      v-on:channelCallback='selectCallback'
      :gameName="gameName"
      :downloadUrl="downloadUrl"
      :loginTypes="loginTypes"
      :autoOpenOS="false"
      channelTips="角色UID可在游戏中—设置—UID查看"></Login>
    <Os v-if='isShowOs'
      v-on:selectCallback='selectCallback'
      v-on:logoutCallback='osCancell'
      :gameName="gameName"></Os>
    <header :class="'header-login-' + headerLogin + ' header-show-' + pageShow_4">
      <div class="acco">{{ isUserInfo.account }}</div>
      <a :class="'music-btn music-btn-' + isMusic" @click="onMusic()"></a>
      <a v-if="isUserInfo.account == ''" class="logon-btn" @click="logon()" title="登录&切换按钮" href="javascript:;"></a>
      <a v-else href="javascript:;" class="switch-btn" @click="switchBtn()"></a>
    </header>

    <div :class="'invitation-page ' + (isSafari ? 'safari' : '') + ' invitation-page-'+invitationPageShow">
      <div class="page-1" title="第一页-贺卡"
        v-show="pageShow_1">
        <div class="role" v-show="invitationPageShow"></div>
        <transition enter-active-class="animated zoomIn" leave-active-class="animated fadeOutDown" :duration="{ enter: 1000 }">
          <div class="invitation-envelope" v-show="invitationPageShow">
            <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown" :duration="{ enter: 1000 }">
              <div class="invitation-index" v-show="envelope_1_show" title="开业邀请函"></div>
            </transition>
            <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown" :duration="{ enter: 1000 }">     
              <div class="envelope-message" v-show="envelope_2_show" title="信封消息">
                <div class="font-box">
                  <p class="p-1"></p>
                  <p class="p-2"></p>
                  <p class="p-3"></p>
                </div>
                <div class="btn-box"></div>
              </div>
            </transition>
          </div>
        </transition>
        <div class="bg">
          <div class="flower-top" v-show="invitationPageShow"></div>
          <div class="flower-bottom" v-show="invitationPageShow"></div>
        </div>
        <div :class="'scissors scissors-' + scissorsOff" v-swiperight="(e)=>vueTouch('右滑',e)" title="剪刀">
        </div>
        <div class="download-box"><a class="download-btn" @click="onDownload()" href="javascript:;"></a></div>
        <div class="next-btn" v-show="envelope_2_show" @click="switchContent()" title="选择题按钮"></div>
      </div>
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
        <div class="page-2 medium-page" title="第二页-时空通道"
          v-show="pageShow_2" >
          <div :class="'leave-btn leave-btn-'+preventShow" @click="closeVideo()"></div>
          <video 
            webkit-playsinline='true'
            playsinline='true'
            preload="auto"
            autoplay
            x5-video-player-type="h5-page"
            x-webkit-airplay="true"
            x5-video-player-fullscreen="true"
            x5-video-ignore-metadata="true"
            controlslist="nodownload nofullscreen"
            :src="video_url_1" class="video-1" id="video-1"></video>
        </div>
      </transition>
      <div class="page-3 medium-page" title="第三页-pv视频"
        v-show="pageShow_3">
        <div :class="'leave-btn leave-btn-'+preventShow" @click="closeVideo()"></div>
        <video 
          webkit-playsinline='true'
          playsinline='true'
          preload="auto"
          autoplay
          x5-video-player-type="h5-page"
          x-webkit-airplay="true"
          x5-video-player-fullscreen="true"
          x5-video-ignore-metadata="true"
          controlslist="nodownload nofullscreen"
          :src="video_url_2" class="video-2" id="video-2"></video>
      </div>
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
        <div class="page-4" title="第四页-对话内容"
          @click="dialogingNext(dialoging)"
          v-show="pageShow_4">
          <b :class="'shade-top shade-top-'+shadeShow"></b>
          <b :class="'shade-bottom shade-bottom-'+shadeShow"></b>
          <transition enter-active-class="animated slideInDown" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
            <div class="title" v-show="roleAniShow"></div>
          </transition>
          <transition enter-active-class="animated slideInLeft" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
            <div class="role role-1" v-show="roleAniShow"></div>
          </transition>
          <transition enter-active-class="animated slideInRight" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
            <div class="role role-2" v-show="roleAniShow"></div>
          </transition>
          <div class="bed"></div>
          <transition enter-active-class="animated bounceInUp" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
            <div :class="'dialog-box dialog-box-' + dialoging"
              v-show="dialogingAniShow">
              <p v-html="currentDialogText"></p>
            </div>
          </transition>
        </div>
      </transition>
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
      <div class="page-5" ref="pageContent" title="第五页-内容页面" v-show="pageShow_5">
        <div class="content-1">
          <div class="banner-swiper">
            <img class="img-1" v-if="bannerIndex == 0" src="https://download4.qcplay.com/qcgame-api/VRrQIDjQaoT9V0JWhAl9oERgnawj79CxVffYRkfU.png">
            <img class="img-2" v-if="bannerIndex == 1" src="https://download4.qcplay.com/qcgame-api/VzTxAIMPS0M6KdZlLFm3QYPXp9SlvZuEHFBnvkds.png">
            <img class="img-3" v-if="bannerIndex == 2" src="https://download4.qcplay.com/qcgame-api/wBe32OBGvEHOelsJMK841osWPoqrbDAshD6efPbW.png">
            <div :class="'pagination pagination-' + bannerIndex">
              <i class="i-1"></i><i class="i-2"></i><i class="i-3"></i>
            </div>
          </div>
        </div>
        <div class="content-2">
          <div class="gift-box-1">
            <a href="javascript:;" class="btn" @click="openPayment()"></a>
          </div>
          <div class="invite-box">            
            <a href="javascript:;" v-for="(item, index) in isActivity.record_list" :key="index">              
              <b v-if="item.use_account.length == ''" class="number-null" @click="openShare(item.code)"></b>
              <b v-else class="number">尾号<br/>{{ item.use_account }}</b>
            </a>
          </div>
          <div class="gift-box-2">
            <a href="javascript:;" :class="'btn btn-' +  isActivity.is_get" @click="openReward()"></a>
          </div>
          <div class="arrow-bottom" @click="clickToLastPage()"></div>
        </div>
        <div :class="'footer-float footer-float-'+isToBottom">
          <div class="open">
            <a class="giftpack-btn" @click="scrollToBottom()" href="javascript:;"></a>
            <a class="download-btn" @click="onDownload()" href="javascript:;"></a>
          </div>
        </div>
      </div>
      </transition>
      <transition enter-active-class="animated slideInUp" leave-active-class="animated slideOutDown" :duration="{ enter: 1000 }">
        <div class="page-6" v-show="pageShow_6">
          <!-- <div class="title"></div> -->
          <div class="btn-box">
            <a href="javascript:;" class="download-btn" @click="onDownload()"></a>
            <a href="javascript:;" class="official-btn" @click="onOfficial()"></a>
            <a href="javascript:;" class="return-btn" @click="clickToLastPage()"></a>
          </div>
        </div>
      </transition>
    </div>

    <audio id="bgMusic" ref="bgMusic" controls="controls" loop="loop" style="display: none;">
      <source src="https://download4.qcplay.com/h5-images/active/travel/invitation/header/music.mp3" type="audio/mpeg">
    </audio>

    <!-- 领取教程弹窗 -->
    <div class="prevent-wrap payment-wrap" v-show="paymentShow">
      <transition enter-active-class="animated zoomInNew" :duration="{ enter: 1000 }">
        <div class="payment-box" v-show="paymentShow">
          <div>
            <img src="https://download4.qcplay.com/h5-images/active/travel/invitation/payment_img.png">
          </div>
          <a class="wiki-btn" @click="openWiki()"></a>
        </div>
      </transition>
      <div class="close-bg" @click="paymentShow = false"></div>
    </div>

    <!-- 分享弹窗 -->
    <div class="prevent-wrap share-wrap" v-show="shareShow">
      <transition enter-active-class="animated zoomInNew" :duration="{ enter: 1000 }">
        <div class="share-box" v-show="shareShow">
          <a href="javascript:;"           
            @click="onCopy()" 
            class="copy-btn" 
            id="clipboard-btn" 
            data-event="复制邀请链接" 
            :data-clipboard-text="clipInfo + shareLink"></a>
          <b class="close-btn" @click="shareShow = false"></b>
        </div>
      </transition>
      <div class="close-bg" @click="shareShow = false"></div>
    </div>

    <!-- 领取成功 -->
    <div class="prevent-wrap success-wrap" v-show="successShow">
      <transition enter-active-class="animated zoomInNew" :duration="{ enter: 1000 }">
        <div class="success-box" v-show="successShow">
          <b class="close-btn" @click="successShow = false"></b>
        </div>
      </transition>
      <div class="close-bg" @click="successShow = false"></div>
    </div>

    <!-- 注销弹窗 -->
    <div class="logout-wrap popup_wrap" v-show="logoutShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="logout-box popup_wrap-box" v-show="logoutShow">
          <p>是否退出当前账号</p>
          <a class="left-btn" href="javascript:;" @click="logoutShow = false">取消</a>
          <a class="right-btn" href="javascript:;" @click="logoutBtn()">确定</a>
        </div>
      </transition>
    </div>

    <!-- 微信提示弹窗 -->
    <div class="download-wrap popup_wrap" v-show="downloadShow" @click="downloadShow = false"></div>
    

    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>

</template>
<script>
import { Toast, Indicator } from 'mint-ui';
import Clipboard from 'clipboard';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import { generateWikiLink } from '@/api/active';
import { onGetInitDataAPI, onLogoutApi, onVipStoreApi, onCodeUpdateAPI, onDownloadApi } from '../api';
import { getTimeStamp, getRandomString, buriedLogger, analysisParams } from '@/utils/utils';

export default {
  name: 'vip',
  components: {
    Login,
    Os,
  },
  data () {
    return {
      gameName: 'travel',
      logger: null,
      downloadUrl: 'https://sglxs.qingcitimes.com/',
      loginTypes: ["sms", "password"],
      is_access_token: '',
      isMusic: false,
      preloadingShow: true,
      logoutShow: false,
      headerLogin: false,
      titleShow: true,
      preventShow: false,
      shareLink: '',
      invitationPageShow: false,
      isWechatBrowser: false, // 是否为微信浏览器
      isSafari: false,
      scissorsOff: false,
      pageShow_1: true,
      envelope_1_show: true,
      envelope_2_show: false,
      pageShow_2: false,
      pageShow_3: false,
      pageShow_4: false,
      pageShow_5: false,
      pageShow_6: false,
      shadeShow: false,
      roleAniShow: false,
      dialoging: false,
      dialogingAniShow: false,
      dialogingNum: 0,
      dialogText: '???B冈布奥，这位是你请来的救兵？B',
      dialogText2: '???B......啊，你醒啦！B',
      currentDialogText: '',
      bannerIndex: 0,
      storage_url_2: 'https://download4.qcplay.com/travel/invitation/pv.mp4', 
      video_url_1: 'https://download4.qcplay.com/travel/invitation/vortex.mp4', 
      video_url_2: '',
      paymentShow: false,
      shareShow: false,
      successShow: false,
      downloadShow: false,
      clipInfo: '',
      isToBottom: false,
      isToArrow: true,
     
      isActivity: {
        is_bind: '',
        is_get: '',
        is_new: '',
        is_reward_start: '',
        is_running: '',
        nick_name: '',
        platform: '',
        record_list: [],
        role_id: '',
        role_name: '',
        server_id: '',
        server_name: '',
        user_id: '',
      },
      isUserInfo: {
        account: '',
      },      
      wechatGroupLink: null,   
      new_record: '',
      type_url: '',
    };
  },
  created () {
    // 测试
    // this.pageShow_1 = false;
    // this.pageShow_2 = false;
    // this.pageShow_3 = false;
    // this.pageShow_4 = false;
    // this.pageShow_5 = true;


    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();

    // 获取
    const params = analysisParams(window.location.href);
    this.type_url = params.type;
    console.log('type', this.type_url);

    this.init(); 

    // 页面进入动画
    setTimeout(() => {
      this.preloadingShow = false;  
      this.invitationPageShow = true;
    }, 500);

    // 埋点
    const bl = buriedLogger('travel', '时光电子邀请函');
    this.logger = bl;
    
    this.isSetShare();

    // 页面中的轮播功能
    this.bannerSwiper();

    // 生成一键加群的链接
    this.onGenerationWiki();
  },
  mounted () {
    this.$refs.pageContent.addEventListener('scroll', this.checkScroll);
    this.$nextTick(() => { this.monitoringEquipment() })
  },
  beforeDestroy() {
    this.$refs.pageContent.removeEventListener('scroll', this.checkScroll);
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler (newValue, oldValue) {
        // console.log('oldValue------>',oldValue)
        // console.log('newValue------>',newValue)
        if (!newValue.account) {
          // TAG: 注销的时候
          // this.clearActiveInfo();
        } else {
          onGetInitDataAPI({access_token: this.is_access_token}).then(response => {
            this.onInitState(response)
          });  
        }
      }
    },
  },
  methods: {
    monitoringEquipment () {
      const { protocol, host } = window.location;
      if (!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) location.href = `${protocol}//${host}/travel/invitation/pc${getTimeStamp()}`
    },
    // 初始化
    init() {
      this.is_access_token = localStorage.getItem('access_token');   
      onGetInitDataAPI({access_token: this.is_access_token}).then(response => {
        this.onInitDataCallback(response);
        this.titleShow = true;
        this.preloadingShow = false;
        this.onInitState(response)
      });
    },    
    // 登录弹窗
    logon() {
      this.changeLoginPopup(true);
      this.logger.sum('时光旅行社_vip电子邀请函H5_点击头部登录按钮');
    },
    switchBtn() {
      this.logoutShow = true;
      this.logger.sum('时光旅行社_vip电子邀请函H5_点击头部切换录按钮');
    },
    onInitState(response) {
      const { code } = response || {}
      if (Number(code) === 200) {
        this.setActivity(response.data.activity);
        this.setUserinfo(response.data.user_info);
        this.logger.sum('时光旅行社_vip电子邀请函H5_初始化');
        return
      }
      // 很抱歉，请先登录！
      if (Number(code) === 403) {
        this.changeLoginPopup(true);
        return
      }
      this.onToast(response.message);
    },
    // 活动内容
    setActivity(data) {
      this.isActivity = data;
      this.headerLogin = true;      
      if(window.localStorage.getItem('new_record') !== null) {
        this.pageShow_1 = false;
        this.pageShow_5 = true;
      }
    },
    // 个人信息
    setUserinfo(data) {
      this.isUserInfo = data;
    },
    // 清除data里面相关数据
    clearActiveInfo() {
    },
    // 滑动监控
    vueTouch(action) {
      if(action == "右滑") {        
        if(this.isUserInfo.account !== '') {
          this.scissorsOff = true;
          this.envelope_1_show = false;
          this.envelope_2_show = true;
          this.logger.sum('时光旅行社_vip电子邀请函H5_右滑动');
        } else {
          this.changeLoginPopup(true);
        }
      }      
    },
    clickToLastPage() {
      this.pageShow_5 = !this.pageShow_5;
      this.pageShow_6 = !this.pageShow_6;
    },
    bannerSwiper() {
      let data = ['1', '2', '3']; // 你想要遍历的数据
      this.bannerIndex = 0; // 初始索引
      let intervalId = setInterval(() => {
        this.bannerIndex = this.bannerIndex+1;
        if (this.bannerIndex >= data.length) {
          this.bannerIndex = 0;
        }
      }, 2000); // 每3秒执行一次
    },
    // 切换内容
    switchContent() {
      var _this = this;
      var Media = document.getElementById('video-1');
      var Media2 = document.getElementById('video-2');
      this.pageShow_2 = true;
      this.pageShow_1 = false;

      Media.play();

      // 音乐关闭
      this.isMusic = false;

      // 第一个视频开始
      Media.addEventListener('ended', function () { //结束       
        _this.pageShow_2 = false; 
        _this.pageShow_3 = true;
        // 替换pv视频url
        _this.video_url_2 = _this.storage_url_2;

        Media2.play();
        // 第二个视频开始
        Media2.addEventListener('ended', function () { //结束
          // 第二个视频结束
          _this.closeVideo();
        }, false);
      }, false);
    },
    // 关闭视频
    closeVideo() {      
      this.preventShow = true;
      this.pageShow_1 = false;
      this.pageShow_2 = false;
      this.pageShow_3 = false;
      var Media = document.getElementById('video-1');
      var Media2 = document.getElementById('video-2');
      Media.pause();
      Media2.pause();
      this.logger.sum('时光旅行社_vip电子邀请函H5_点击跳过视频按钮');
      setTimeout(() => {
        // 睡醒动画
        this.isMusic = true;
        this.$refs.bgMusic.play();
        this.dialogueAni();

      }, 100)      
    },
    // 睡醒动画
    dialogueAni() {
      this.pageShow_1 = false;            // a.pv播放完毕后的睁眼对话页      
      this.pageShow_4 = true;
      setTimeout(() => {
        this.shadeShow = true;            // b.眨眼效果
        setTimeout(() => {                
          this.roleAniShow = true;        // c.角色出现  
          setTimeout(() => {
            this.dialogingAniShow = true; // d.对话框出现
            setTimeout(() => {
              this.preventShow = false;
              this.autoPrint(this.dialogText)
            }, 800)
          }, 1000)
        }, 4000)
      }, 1000); 
    },
    // 点击对话内容
    dialogingNext(state) {
      if(this.dialogingNum < 2) {
        if(state) {
          this.currentDialogText = '';
          this.autoPrint(this.dialogText2)
          this.dialoging = false;
        }
      } else {
        this.pageShow_4 = false;
        this.pageShow_5 = true;

        window.localStorage.setItem("new_record", 'record');
      }      
    },
    // 打印初始文字
    autoPrint(info) {
      const text = info;
      const textArr = text.split('');
      const loop = () => {
        setTimeout(() => {
          const str = textArr.shift(0, 1);
          str === 'B' 
          ? this.currentDialogText += `<br />` 
          : this.currentDialogText += str
          if (textArr.length !== 0) {
            loop()
            return
          }
          setTimeout(() => {
            this.dialogingNum++
            this.dialoging = true;
          }, 500)
        }, 80);
      }
      loop()
    },
    // 领取教程弹窗
    openPayment() {
      this.paymentShow = true;
      this.logger.sum('时光旅行社_vip电子邀请函H5_点击领取教程弹窗');
    },
    // 打开分享
    openShare() {
      this.preventShow = true;
      onCodeUpdateAPI().then(response => {
        const { code } = response || {}        
        setTimeout(() => { this.preventShow = false; }, 300);
        if (Number(code) === 200) {
          this.shareShow = true;
          const { protocol, host } = window.location;
          this.shareLink = `${protocol}//${host}/travel/invitation/help${getRandomString()}?code_id=${response.data.data}`;
          this.clipInfo = '尊敬的青瓷VIP3用户' + this.isUserInfo.account.substr(-4) +'! '+ '送来一份时光启动礼包~收好我的爱,困难say goodby~点击链接领取：';
          return
        }
        this.onToast(response.message);     
      });
    },
    // 账号注销按钮
    logoutBtn() {
      onLogoutApi().then(response => {
        const { code } = response || {}
        if (Number(code) === 200) {
          this.headerLogin = false;
          this.logoutShow = false;
          this.clearData();
        }
        this.onToast(response.message);
      });
    },
    // 数据清除 并 初始化
    clearData() {
      
      Object.keys(this.isActivity).forEach(key=>{this.isActivity[key]=''});
      Object.keys(this.isUserInfo).forEach(key=>{this.isUserInfo[key]=''});

      // 页面恢复第一页
      this.scissorsOff = false;
      this.pageShow_1 = true;
      this.envelope_1_show = true;
      this.envelope_2_show = false;
      this.pageShow_2 = false;
      this.pageShow_3 = false;
      this.pageShow_4 = false;
      this.pageShow_5 = false;      
      this.shadeShow = false;
      this.roleAniShow = false;
      this.dialoging = false;
      this.dialogingAniShow = false;
      this.dialogingNum = 0;
      this.currentDialogText = '';      
      window.localStorage.setItem("access_token", '');
    },
    // 点击领取礼包
    openReward() {
      if(this.isActivity.is_get == false) {
          if (this.isUserInfo.account === undefined || this.isUserInfo.account === '') {
          this.changeLoginPopup(true);
          return
        }
        this.changeOsPopup(true);
        return
      }
      this.onToast('您已领取过奖励！');
    },
    // 滑动至页面尾部
    scrollToBottom() {
      console.log(this.$refs.pageContent.scrollHeight)
      this.$refs.pageContent.scrollTop = this.$refs.pageContent.scrollHeight - 1700;
      this.isToBottom = true;
    },
    // 是否至底
    checkScroll() {
      const container = this.$refs.pageContent;
      container.scrollTop + container.clientHeight >= container.scrollHeight - 900
      ? this.isToBottom = true : this.isToBottom = false;
    },
    // 选择角色后
    selectCallback () {
      onVipStoreApi().then(response => {
        const { code } = response || {}
        if (Number(code) === 200) {
          this.successShow = true;
          onGetInitDataAPI({access_token: this.is_access_token}).then(response => {
            this.onInitState(response);
          });
          this.logger.sum('时光旅行社_时光电子邀请函H5_vip3挚友携行礼包领取成功');
          return
        }
        this.onToast(response.message);
      });
    },
    // 区组弹窗注销-相关参数复位
    osCancell () {
      this.headerLogin = false;
      this.logoutShow = false;
      this.clearData();
    },
    // TAG: 其他简易封装的方法
    onToast (config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    // 复制链接
    onCopy () {
      this.logger.sum('时光旅行社_时光电子邀请函H5_点击弹窗中的复制按钮');
      const clipboard = new Clipboard('#clipboard-btn');
      clipboard.on('success', (e) => {
        this.onToast('复制成功');
        e.clearSelection();
      });
      clipboard.on('error', (e) => {
        this.onToast('复制失败');
      });
    },
    onDownload() {
      // 微信
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.downloadShow = true;
        return
      };
      // 如果带type则使用type的地址
      if (/(Android)/i.test(navigator.userAgent) && this.type_url !== undefined) {
        this.logger.sum('时光旅行社_时光电子邀请函H5_短信分包'+this.type_url+'下载');
        location.href = 'https://download4.qcplay.com/apk-v2/'+this.type_url+'.apk';
        return
      };
      onDownloadApi().then(response => {
        const { code } = response || {}
        if (Number(code) === 200) {
          if (/(Android)/i.test(navigator.userAgent)) {
            if (response.data.android_down_url == '' || response.data.android_down_url == null) {
              this.onToast('安卓下载暂未开放，敬请期待！<br/>详情请关注官方qq群：666341871', {time:3000});
            } else {
              this.logger.sum('时光旅行社_时光电子邀请函H5_官方安卓下载');
              location.href = 'https://download4.qcplay.com/apk-v2/qc-kol-1141322.apk';
            }
          };
          if (/(iphone)/i.test(navigator.userAgent)) {
            if (response.data.ios_down_url == '' || response.data.ios_down_url == null) {
              this.onToast('ios下载暂未开放，敬请期待！<br/>详情请关注官方qq群：666341871', {time:3000});
            } else {              
              this.logger.sum('时光旅行社_时光电子邀请函H5_官方IOS下载');
              location.href = response.data.ios_down_url
            }
          };
          return
        }
        this.onToast(response.message);
      });      
    },
    onMusic() {
      this.isMusic = !this.isMusic;
      console.log('aaa', this.$refs.bgMusic)
      if (this.$refs.bgMusic.paused) {
        this.$refs.bgMusic.play()
      } else {
        this.$refs.bgMusic.pause();
      }
    },
    onOfficial() {
      this.logger.sum('时光旅行社_时光电子邀请函H5_点击前往官网按钮');
      location.href = this.downloadUrl;
    },
    openWiki() {
      this.logger.sum('时光旅行社_时光电子邀请函H5_点击前往小程序wiki');
      location.href = this.wechatGroupLink;
    },
    // 打开wiki小程序
    onGenerationWiki() {
      const wiki_index = localStorage.getItem('wiki_index');
      // 微信加群链接赋值
      if (!wiki_index) {
        generateWikiLink({ path: '/pages/index/index', version: 'release' })
          .then((res) => {
            const open_like = res.data.open_like;
            this.wechatGroupLink = open_like;
            window.localStorage.setItem("wiki_index", open_like);
          });
      } else {
        this.wechatGroupLink = wiki_index;
      }
    },
    // 微信分享
    isSetShare () {
      this.setShare({
        link: `https://h5.qingcigame.com/travel/invitation/enter${getRandomString()}`,
        title: '时光旅行社贵宾邀请函',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/aFRAFaBaBj7IP3W7Iq9QFrI1w5HjzAqLpo3vZLPL.png',
        desc: '尊敬的青瓷VIP3用户，时光旅行社现已开业，诚邀您光临~'
      })
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
};
</script>

<style lang="less">
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/travel/invitation/index/index.vue